import React from 'react';
import styled from 'styled-components';

import SearchTextField from '../SearchTextField';

import IconSearch from '../../assets/svgs/header/search.svg';

const SCSearchIcon = styled(IconSearch)`
  cursor: pointer;
`;

const Search = ({ isActive, onClick }) => {
  return isActive ? (
    <SearchTextField onSearchIconClick={onClick} iconSize={40} />
  ) : (
    <SCSearchIcon onClick={onClick} size={40} />
  );
};

export default Search;
